import { render, staticRenderFns } from "./DxListManage.vue?vue&type=template&id=163fe4f9&scoped=true"
import script from "./DxListManage.vue?vue&type=script&lang=js"
export * from "./DxListManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163fe4f9",
  null
  
)

export default component.exports